import { selectorFamily } from 'recoil' 
import { layerDefsAtomFamily } from "../layerDefsAtoms";

export const layerOverLayersSelector = selectorFamily({
  key: "layer-over-layers-selector",
  get:
    (layerID) =>
    ({ get }) => {
      const layerDef = get(layerDefsAtomFamily(layerID));
      return layerDef.overLayers
    },
  set:
    (layerID) =>
    ({ set, get }, newOverLayers) => {
      setLayerOverLayers(newOverLayers, layerID, set);
    },
});

const setLayerOverLayers = (newOverLayers, layerID, set) => {
  set(layerDefsAtomFamily(layerID), (oldLayer) => {
    const newLayer = {
      ...oldLayer
    }

    if (newOverLayers) {
      newLayer.overLayers = newOverLayers
    } else {
      delete newLayer.overLayers
    }

    return newLayer
  });
}
